export class CoaSummary {
  total_records_tb?: number;
  total_mapped?: number;
  total_unmapped?: number;
  missing_data?: number;
  ai_failures?: number;
}

export class CoaSummaryProcessed {
  total_records_from_tb?: number;
  number_rows_mapped?: number;
  number_rows_not_mapped?: number;
  unmapped_missing_account_code_from_coa?: number;
  unmapped_ai_fail?: number;

  static processCoaSummary(coaSummary: CoaSummary): CoaSummaryProcessed {
    const coaSummaryProcessed = new CoaSummaryProcessed();

    const def_zero = (val: number | undefined) => val || 0;

    coaSummaryProcessed.total_records_from_tb = def_zero(
      coaSummary?.total_records_tb
    );

    coaSummaryProcessed.number_rows_mapped = def_zero(coaSummary?.total_mapped);

    coaSummaryProcessed.number_rows_not_mapped = def_zero(
      coaSummary?.total_unmapped
    );

    coaSummaryProcessed.unmapped_missing_account_code_from_coa = def_zero(
      coaSummary?.missing_data
    );

    coaSummaryProcessed.unmapped_ai_fail = def_zero(coaSummary?.ai_failures);

    return coaSummaryProcessed;
  }
}
